import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) return toast.error("Password must be 6+ characters");
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success("Welcome to KYRO!");
      nav("/account");
    } catch (err) { toast.error(err?.response?.data?.detail || "Registration failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-5 py-14">
      <div className="w-full max-w-md">
        <div className="kyro-card p-8 md:p-10">
          <div className="kyro-overline mb-3">Create account</div>
          <h1 className="font-display font-black text-3xl tracking-tighter mb-2">Join Baba Media</h1>
          <p className="text-sm text-kyro-mute mb-8">One vault for every premium subscription.</p>

          <form onSubmit={submit} className="space-y-3">
            <input data-testid="register-name" type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Full name" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 outline-none focus:border-[#FF4433]" />
            <input data-testid="register-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 outline-none focus:border-[#FF4433]" />
            <input data-testid="register-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password (min 6 chars)" className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 outline-none focus:border-[#FF4433]" />
            <button data-testid="register-submit-btn" disabled={loading} className="w-full kyro-btn-primary flex items-center justify-center gap-2">
              {loading ? "Creating..." : <>Create account <ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>

          <p className="text-sm text-kyro-mute mt-6 text-center">
            Already have an account? <Link to="/login" className="text-[#FF4433] font-semibold hover:underline" data-testid="link-to-login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
